module.exports = __webpack_public_path__ + "img/clockIn-yes.6286f33c.svg";